<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        header: 'Displays',
        body: [
          'The Data Mart panel lists the active and inactive data marts along with the respective record counts and last synchronization dates.The user can add a data mart by clicking the + icon',
          'To add a data mart, select the type of data mart and edit the display name and table name.Add the connection URL along with the username and password. Remember to prime the destination table before turning on synchronization.',
          'The user can click the drill through icon to see the data mart details. While viewing an individual data mart panel, the user can re-synch the data mart, edit the data mart properties or delete the data mart. Note: The user can set the data mart to Inactive (Suspended) as opposed to deleting the data mart to be sure the data mart is not in use.'
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
